export const SETUP_STEPS = [
  { slug: 'project', label: 'Project', path: '/setup/project/' },
  { slug: 'keys', label: 'API key', path: '/setup/keys/' },
  { slug: 'integrate', label: 'Integrate', path: '/setup/integrate/' },
  { slug: 'test', label: 'Test', path: '/setup/test/' },
];

export const SETUP_INTEGRATIONS = [
  { slug: 'api', label: 'REST API', description: 'Call os-router with curl or any HTTP client.' },
  { slug: 'python', label: 'Python SDK', description: 'Use the OpenAI Python SDK with os-router.' },
  { slug: 'openrouter', label: 'Replace OpenRouter', description: 'Swap OpenRouter for os-router in existing code.' },
  { slug: 'cursor', label: 'Cursor', description: 'Route Cursor through os-router.' },
  { slug: 'claude-code', label: 'Claude Code', description: 'Point Claude Code at os-router.' },
];

export function setupStepFromPath(pathname) {
  if (pathname.startsWith('/setup/test')) return 4;
  if (pathname.startsWith('/setup/integrate')) return 3;
  if (pathname.startsWith('/setup/keys')) return 2;
  if (pathname.startsWith('/setup/project')) return 1;
  return 1;
}

export function setupPathForStep(step) {
  return SETUP_STEPS[step - 1]?.path || SETUP_STEPS[0].path;
}
